import { ActionTree } from 'vuex'

import FamilyMember from '@/lib/class/FamilyMember'
import { FamilyState } from '@/store/family/types'
import RootState from '@/store/types/RootState'

export default <ActionTree<FamilyState, RootState>>{
  SAVE_FAMILY_MEMBERS({ commit }, familyMembers: FamilyMember[]) {
    commit('saveFamilyMembers', familyMembers)
  },

  UPDATE_FAMILY_MEMBER(
    { commit },
    {
      familyMember,
      username,
    }: { familyMember: FamilyMember; username: string },
  ) {
    commit('updateFamilyMember', {
      familyMember,
      username,
    })
  },

  SAVE_ACCOUNT_HOLDER({ commit }, accountHolder: FamilyMember) {
    commit('saveAccountHolder', accountHolder)
  },

  API_HAS_RESPONDED_WITH_DATA({ commit }) {
    commit('setHasAttemptedToLoadData', true)
  },
}
